<template>
  <app-panel title="Выгрузка данных по начислениям">
    <div class="employee-privileges-container">
      <app-datepicker label="Месяц" minimum-view="month" format="MMMM yyyy" v-model="month" class="mb-4"/>
      <vs-upload
        action="#"
        :limit="1"
        :show-upload-button="false"
        :multiple="false"
        text="Добавить файл"
        class="mx-auto mb-4"
        :class="{'uploader_error': fileError}"
        @change="onFileChange"
        @on-delete="onFileDelete"
        ref="uploader"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      />
      <app-button @click="sendData" color="success" type="border">Отправить</app-button>
    </div>
  </app-panel>
</template>

<script>
export default {
  name: "Privileges",
  data(){
    return {
      file: null,
      month: null,
      fileError: false
    }
  },
  computed: {
    leId(){
      return this.$store.getters['appUser/selectedHouse'].legal_entities_id;
    }
  },
  methods: {
    onFileChange(event, files){
      console.log(event, files);
      this.file = files.filter(file => !file.remove)[0] || null;
      this.fileError = false;
    },
    onFileDelete(){
      this.file = null;
    },
    downloadFile(url) {
      let link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('href', this.$options.filters.imgPath(url));
      link.setAttribute('download', url.split('/').pop());
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      this.$nextTick(() => {
        link.click();
      });
      // document.body.removeChild(link);
    },
    async sendData(){
      if(this.file === null) {
        this.fileError = true;
        return false;
      }

      let formattedMonth = this.$options.filters.formatDate(this.month);

      let body = {
        file: this.file,
        month: formattedMonth,
        le_id: this.leId,
      };

      let bodyFormData = new FormData();

      for(let key in body){
        if(body.hasOwnProperty(key)){
          if(Array.isArray(body[key])){
            for(let i = 0; i < body[key].length; i++){
              bodyFormData.append(`${key}[${i}]`, body[key][i]);
            }
          }
          else{
            bodyFormData.append(key, body[key])
          }
        }
      }
      try{
        this.$vs.loading({type:'default'});

        let {data} = await this.$http.post('fillform/fill_privileges_form', bodyFormData, {
          headers: {
            'Content-Type': 'multipart/form-data;'
          }
        });

        this.$vs.loading.close();

        this.$nextTick(() => {
          this.$vs.notify({color: 'success', title: "Успешная генерация", text: 'Файл сгенерирован, скоро начнется скачивание'});
        });

        if(data.path){
          this.downloadFile(data.path);
        }
      }
      catch(e){
        this.$vs.loading.close();
        console.error(e);
        this.$nextTick(() => {
          if (e.response) {
            if (e.response.status === 403) {
              this.$vs.notify({color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав'});
            } else {
              this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже'});
            }
          } else {
            this.$vs.notify({color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка'});
          }
        });
      }
    }
  },
  created(){
    this.month = Date.now();
  }
}
</script>

<style lang="scss">
.employee-privileges-container{
  width: 220px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .con-img-upload{
    padding: 0;
  }

  .con-input-upload{
    margin: 0 auto;
    float: none;
  }

  .con-img-upload .img-upload{
    margin: 10px auto;
    float: none;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .06), 0 1px 4px rgba(0, 0, 0, .08);
  }

  .con-img-upload .img-upload .text-archive span{
    font-size: 1rem;
  }

  .uploader_error{
    .con-input-upload{
      border: 1px solid rgba(var(--app-danger), 1);
    }
  }
}
</style>
